import React from 'react';
import { CONTACT_TYPES } from './contact-types';
import { GenericTooltipCell } from '../components/cells';

export const contactSourceToText = {
  LUCILA: 'Fingo',
  PROVIDED_BY_CLIENT: 'Cliente',
};

export const CONTACT_SOURCES = {
  ALL: null,
  PROVIDED_BY_CLIENT: 'PROVIDED_BY_CLIENT',
  LUCILA: 'LUCILA',
};

const CONTACT_TYPES_SOURCES_TO_SHOW = {
  [CONTACT_TYPES.PREOFFER_COMMERCIAL_KEY]: CONTACT_SOURCES.ALL,
  [CONTACT_TYPES.COMMERCIAL]: CONTACT_SOURCES.ALL,
  [CONTACT_TYPES.COMMERCIAL_KEY]: CONTACT_SOURCES.ALL,
  [CONTACT_TYPES.RATIFICATION]: CONTACT_SOURCES.ALL,
  [CONTACT_TYPES.COLLECTION]: [
    CONTACT_SOURCES.PROVIDED_BY_CLIENT,
    CONTACT_SOURCES.LUCILA,
  ],
};

export const getContactTypeSourcesToShow = (
  contactType,
) => CONTACT_TYPES_SOURCES_TO_SHOW[contactType] ?? CONTACT_SOURCES.ALL;

export const contactTypeToText = {
  PREOFFER_COMMERCIAL_KEY: 'Sí',
  COMMERCIAL: 'No',
};

export const CONTACT_COLUMNS = [
  {
    field: 'name',
    headerName: 'Nombre',
    type: 'string',
    minWidth: 100,
    align: 'center',
    editable: true,
    flex: 1,
  },
  {
    field: 'position',
    headerName: 'Cargo',
    type: 'string',
    minWidth: 120,
    align: 'center',
    editable: true,
    flex: 1,
  },
  {
    field: 'phoneNumber',
    headerName: 'Teléfono',
    type: 'string',
    minWidth: 100,
    align: 'center',
    editable: true,
    flex: 1,
  },
  {
    field: 'email',
    headerName: 'Correo',
    type: 'string',
    minWidth: 140,
    align: 'center',
    editable: true,
    flex: 3,
    renderCell: ({ row }) => (<GenericTooltipCell data={row.email} />),
  },
  {
    field: 'source',
    headerName: 'Fuente',
    type: 'singleSelect',
    minWidth: 120,
    align: 'center',
    valueOptions: [CONTACT_SOURCES.PROVIDED_BY_CLIENT, CONTACT_SOURCES.LUCILA],
    valueFormatter: ({ value }) => contactSourceToText[value],
    editable: true,
    flex: 1,
  },
];
